import { render, staticRenderFns } from "./property-type-leed.vue?vue&type=template&id=3c938a66"
import script from "./property-type-leed.vue?vue&type=script&lang=js"
export * from "./property-type-leed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports